import { serviceLocator } from '@/utils/providers/serviceLocator'
import { CurrentUserRepository } from '../repositories/CurrentUserRepository'
import { useQuery } from '@/utils/asyncStateManagement/useQuery'
import { useCurrentUserStore } from '../../presentation/stores/currentUserStore'

export async function addCurrentUserInfoCase() {
  const newRepository = serviceLocator.getService<CurrentUserRepository>('CurrentUserService')
  const currentUserStore = useCurrentUserStore()

  const { data } = await useQuery({
    fetcher: async () => await newRepository?.getCurrentUser(),
    key: 'currentUser',
    filterData: JSON.stringify('')
  })

  if (data.value?.error) return
  currentUserStore.addCurrentUserData(data.value)
  const rolesResponse = await useQuery({
    fetcher: async () => await newRepository?.getCurrentUserRoles(),
    key: 'currentUserRoles',
    filterData: JSON.stringify('')
  })
  if (rolesResponse.error.value) return
  currentUserStore.addCurrentUserRoles(rolesResponse.data.value)
  const authRolesResponse = await useQuery({
    fetcher: async () => await newRepository?.getCurrentUserAuthRoles(),
    key: 'currentUserAuthRoles',
    filterData: JSON.stringify('')
  })
  if (authRolesResponse.error.value) return
  currentUserStore.addCurrentUserAuthRoles(authRolesResponse.data.value)
}
